import DocumentTitle from "react-document-title";
import { useNotifications } from "../../data/hooks";
import { Result, Spin, Timeline } from "antd";
import MobileHeader from "../Components/MobileHeader";
import { Link } from "react-router";
import { RoutePaths } from "../routes";
import Button from "../Components/Button";
import { NotificationType } from "../../data/types";
import { useEffect, useState } from "react";
import { Id } from "../../data/types";
import { fetchProfile } from "../../data/firestore/profile";
import { analyticsReportError } from "../../data/firebase/analytics";
import dayjs from "dayjs";
import { FriendAdded } from "./Notifications/FriendAdded";
import { FriendAddedWish } from "./Notifications/FriendAddedWish";

export default function Notifications() {
  const { notifications, isLoaded } = useNotifications();
  const [names, setNames] = useState<Record<Id, string>>({});
  useEffect(() => {
    for (const n of notifications || []) {
      if (!(n.sourceUserId in names)) {
        fetchProfile(n.sourceUserId)
          .then((friendProfile) =>
            setNames((curNames) => ({
              ...curNames,
              [n.sourceUserId]: friendProfile.displayName,
            })),
          )
          .catch(analyticsReportError);
      }
    }
  }, [notifications, names]);
  if (!isLoaded) {
    return (
      <div className="m-20">
        <Spin />
      </div>
    );
  }
  const title = "Notifications";
  if (typeof notifications == "undefined" || notifications.length === 0) {
    return (
      <DocumentTitle title={title}>
        <>
          <MobileHeader title={title}>
            <></>
          </MobileHeader>

          <Result
            icon={<div className="text-5xl">🫥</div>}
            title="No notifications!"
            subTitle="You friends' new wishes will appear here!"
            extra={
              <Link to={RoutePaths.myDefaultWishlist} viewTransition>
                <Button>Back to my wishlist</Button>
              </Link>
            }
          />
        </>
      </DocumentTitle>
    );
  }
  const items = notifications?.map((notification) => {
    let title = <>UNKNOWN</>;
    switch (notification.type) {
      case NotificationType.FriendAdded:
        title = <FriendAdded notification={notification} />;
        break;
      case NotificationType.FriendAddedWish:
        title = <FriendAddedWish notification={notification} />;
        break;
    }
    return {
      label: dayjs(notification.createdAt).fromNow(),
      children: title,
    };
  });
  return (
    <DocumentTitle title={title}>
      <>
        <MobileHeader title={title}>
          <></>
        </MobileHeader>
        <div className="flex flex-col items-start pl-8 pt-8 md:items-center md:p-8">
          <Timeline reverse mode="left" items={items} />
        </div>
      </>
    </DocumentTitle>
  );
}
